import { render } from "./ItemNavigator.vue?vue&type=template&id=9fa3d6a6&scoped=true&ts=true"
import script from "./ItemNavigator.vue?vue&type=script&lang=ts"
export * from "./ItemNavigator.vue?vue&type=script&lang=ts"

import "./ItemNavigator.vue?vue&type=style&index=0&id=9fa3d6a6&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa3d6a6"]])

export default __exports__